// prettier-ignore
import * as core from "@alloy-js/core";
import * as base from "../index.js";

export const ArrayExpression = core.stc(base.ArrayExpression);
export const ArrowFunction = core.stc(base.ArrowFunction);
export const BarrelFile = core.stc(base.BarrelFile);
export const CallSignature = core.stc(base.CallSignature);
export const ClassDeclaration = core.stc(base.ClassDeclaration);
export const ClassField = core.stc(base.ClassField);
export const ClassMember = core.stc(base.ClassMember);
export const ClassMethod = core.stc(base.ClassMethod);
export const CommaList = core.stc(base.CommaList);
export const Declaration = core.stc(base.Declaration);
export const EnumDeclaration = core.stc(base.EnumDeclaration);
export const EnumMember = core.stc(base.EnumMember);
export const ExportStatement = core.stc(base.ExportStatement);
export const FunctionCallExpression = core.stc(base.FunctionCallExpression);
export const FunctionDeclaration = core.stc(base.FunctionDeclaration);
export const FunctionExpression = core.stc(base.FunctionExpression);
export const IfStatement = core.stc(base.IfStatement);
export const ElseClause = core.stc(base.ElseClause);
export const ElseIfClause = core.stc(base.ElseIfClause);
export const ImportStatement = core.stc(base.ImportStatement);
export const ImportStatements = core.stc(base.ImportStatements);
export const InterfaceDeclaration = core.stc(base.InterfaceDeclaration);
export const InterfaceExpression = core.stc(base.InterfaceExpression);
export const InterfaceMember = core.stc(base.InterfaceMember);
export const InterfaceMethod = core.stc(base.InterfaceMethod);
export const JSDoc = core.stc(base.JSDoc);
export const JSDocExample = core.stc(base.JSDocExample);
export const JSDocComment = core.stc(base.JSDocComment);
export const MemberExpression = core.stc(base.MemberExpression);
export const NewExpression = core.stc(base.NewExpression);
export const ObjectExpression = core.stc(base.ObjectExpression);
export const ObjectProperty = core.stc(base.ObjectProperty);
export const PackageDirectory = core.stc(base.PackageDirectory);
export const PackageJsonFile = core.stc(base.PackageJsonFile);
export const Reference = core.stc(base.Reference);
export const SourceFile = core.stc(base.SourceFile);
export const SwitchStatement = core.stc(base.SwitchStatement);
export const CaseClause = core.stc(base.CaseClause);
export const TSConfigJson = core.stc(base.TSConfigJson);
export const FunctionType = core.stc(base.FunctionType);
export const TypeDeclaration = core.stc(base.TypeDeclaration);
export const TypeRefContext = core.stc(base.TypeRefContext);
export const ValueExpression = core.stc(base.ValueExpression);
export const VarDeclaration = core.stc(base.VarDeclaration);
